import {defineStore} from "pinia";
import { getRefreshedToken } from "@/services/user.service";

// Consente la sincronizzazione dei token quando vengono
// aggiornati da un'altra scheda
const bc = new BroadcastChannel("token_refresh");

const useAuthStore = defineStore('auth', {
  state: () => ({
    user: localStorage.getItem('AM_USER') ? JSON.parse(localStorage.getItem('AM_USER')) : null,
    company: null,
    accounts: [],
  }),
  getters: {
    authenticated: (state) => !!state?.user,
  },
  actions: {
    setUser(value) {
      if (value == null) {
        let v = localStorage.getItem('AM_USER')
        if (v !== null) {
          this.user = JSON.parse(v)
        }
      } else {
        localStorage.setItem('AM_USER', JSON.stringify(value))
        this.user = value
      }
    },
    setToken(newToken) {
      let storedUser = JSON.parse(localStorage.getItem("AM_USER"));

      if (!storedUser) return;

      storedUser.access_token = newToken;
      localStorage.setItem("AM_USER", JSON.stringify(storedUser));
      this.user = storedUser;
    },
    logout() {
      this.user = null
      localStorage.removeItem("AM_USER")
    }
  }
});

/**
 * @returns {boolean}
 */
export async function refreshToken() {
  let authStore = useAuthStore();

  if (!authStore.authenticated) return false;

  try {
    let { token } = await getRefreshedToken();
    authStore.setToken(token);
    bc.postMessage(token);
    return true;
  } catch {
    return false;
  }
}

/**
 * Effettua l'aggiornamento di un token quando viene
 * aggiornato da un'altra scheda
 */
bc.onmessage = ({ data: token }) => {
  let authStore = useAuthStore();
  authStore.setToken(token);
}

export default useAuthStore
